import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { zodTemporalInstant } from '../Temporal';
import { zodBrandedString } from '../utils';

const ExportableUsioPaymentAccount = z.object({
  id: z.string(),
  borrowerId: zodBrandedString<BorrowerId>(),
  provider: z.literal('usio'),
  disabled: z.boolean(),
  accountName: z.string(),
  confirmationId: z.string(),
  createdAt: zodTemporalInstant,
  updatedAt: zodTemporalInstant,
});

const ExportableRepayPaymentAccount = z.object({
  id: z.string(),
  borrowerId: zodBrandedString<BorrowerId>(),
  provider: z.literal('repay'),
  disabled: z.boolean(),
  accountName: z.string(),
  lastFour: z.string(),
  addedByCompany: z.boolean(),
  createdAt: zodTemporalInstant,
  updatedAt: zodTemporalInstant,
});

export const ExportablePaymentAccount = z
  .discriminatedUnion('provider', [ExportableUsioPaymentAccount, ExportableRepayPaymentAccount])
  .meta({ title: 'PaymentAccount' });

export type ExportablePaymentAccount = z.infer<typeof ExportablePaymentAccount>;
